// extracted by mini-css-extract-plugin
module.exports = {"trending_box":"blog_trending_box_trending_box__tCAOs","image_wrapper":"blog_trending_box_image_wrapper__3HUKj","cat_title":"blog_trending_box_cat_title__ZB2ml"};